import { Route, Switch } from "react-router-dom";

import { SubdomainProvider } from "./components/SubdomainProvider.js";
import Begin from "./components/Begin.js";
import Bypass from "./components/Bypass.js";
import Cancel from "./components/Cancel.js";
import CompletedMissions from "./components/CompletedMissions.js";
import Confirmed from "./components/Confirmed.js";
import Debrief from "./components/Debrief.js";
import Marble from "./components/Marble.js";
import Mission from "./components/Mission.js";
import Myhistory from "./components/Myhistory.js";
import Myprofile from "./components/Myprofile.js";
import NotFound from "./components/NotFound.js";
import ObeliskTerms from "./components/ObeliskTerms.js";
import Opbc from "./components/Opbc.js";
import PlayerProgress from "./components/PlayerProgress.js";
import Settings from "./components/Settings.js";
import ActorsAdmin from "./components/ActorsAdmin.js";
import TheMission from "./components/TheMission.js";
import YourMission from "./components/YourMission.js";
import YourUpdatedMission from "./components/YourUpdatedMission.js";

// import GiftCards from "./components/GiftCards.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Payment from "./components/Payment.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Privacy from "./components/Privacy.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Private from "./components/Private.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import PrivateConfirmed from "./components/PrivateConfirmed.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Start from "./components/Start.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Reviews from "./components/Reviews.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Terms from "./components/Terms.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED
// import Tickets from "./components/Tickets.js"; THIS HAS BEEN INTENTIONALLY DEPRECATED

function App() {
  return (
    <SubdomainProvider>
      <div className="App">
        {/* MISSION PAGES */}
        <Switch>
        <Route path="/begin" exact>
          <Begin />
        </Route>
        <Route path="/confirmed" exact>
          <Confirmed />
        </Route>
        <Route path="/mission" exact>
          <Mission />
        </Route>
        <Route path="/yourmission" exact>
          <YourMission />
        </Route>
        <Route path="/themission" exact>
          <TheMission />
        </Route>
        <Route path="/myprofile" exact>
          <Myprofile />
        </Route>
        <Route path="/myhistory" exact>
          <Myhistory />
        </Route>
        <Route path="/marble" exact>
          <Marble />
        </Route>
        <Route path="/yourupdatedmission" exact>
          <YourUpdatedMission />
        </Route>
        <Route path="/opbc" exact>
          <Opbc />
        </Route>
        <Route path="/obeliskterms" exact>
          <ObeliskTerms />
        </Route>
        <Route path="/debrief" exact>
          <Debrief />
        </Route>

        {/* ADMIN PAGES */}
        <Route path="/bypass" exact>
          <Bypass />
        </Route>
        <Route path="/cancel" exact>
          <Cancel />
        </Route>
        <Route path="/settings" exact>
          <Settings />
        </Route>
        <Route path="/actors" exact>
          <ActorsAdmin />
        </Route>
        <Route path="/playerprogress" exact>
          <PlayerProgress />
        </Route>
        <Route path="/completedmissions" exact>
          <CompletedMissions />
        </Route>

        {/* GENERAL PAGES */}
        <Route path="/" exact>
          <Begin />
        </Route>
        {/* <Route path="/privacy" exact>
          <Privacy />
        </Route> */}
        {/* <Route path="/terms" exact>
          <Terms />
        </Route> */}
        {/* <Route path="/payment" exact>
          <Payment />
        </Route> */}
        {/* <Route path="/private" exact>
          <Private />
        </Route> */}
        {/* <Route path="/privateconfirmed" exact>
          <PrivateConfirmed />
        </Route> */}
        {/* <Route path="/giftcards" exact>
          <GiftCards />
        </Route> */}
        {/* <Route path="/reviews" exact>
          <Reviews />
        </Route> */}
        {/* <Route path="/tickets" exact>
          <Tickets />
        </Route> */}

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      </div>
    </SubdomainProvider>
  );
}

export default App;
